import { isWeiXin, isWXWork } from "@/utils/platform";
import summarySrcStore from "@/store/summarySrc.store";
import summaryCommonStore from "@/store/summaryCommon.store";
import { ExportType, exportTypeNameMap } from "@/constants/record";
import { Origin } from "@/constants/share";
import fridayReporter from "@/utils/friday";
import { forwardRef, useImperativeHandle, useState } from "react";
import DownloadTip from "@/pages/Share/Mobile/components/DownloadTip";
import ActionSheet from "../ActionSheet";
import useExport from "@/sections/Summary/useExport";

export interface MobileExportModalRef {
  show: () => void;
}

interface MobileExportModalProps {
}

const MobileExportModal = forwardRef<
  MobileExportModalRef,
  MobileExportModalProps
>((_props, ref) => {
  const { summaryDone, srcDone, audioDone, speechDraftDone } = useExport();
  const [showDownloadModal, setShowDownloadModal] = useState(false);
  const [showDownloadTip, setShowDownloadTip] = useState(false);

  const detailInfo = summarySrcStore((state) => state.detailInfo);
  const generatedTitle = summarySrcStore((state) => state.generatedTitle);
  const shareInfo = summaryCommonStore((state) => state.shareInfo);

  const handleShowDownloadModal = () => {
    fridayReporter.pushData({
      eventCode: "summary_h5_download",
    });
    if (isWeiXin() || isWXWork()) {
      setShowDownloadTip(true);
      return;
    }
    setShowDownloadModal(true);
  };
  const handleHideDownloadModal = () => {
    setShowDownloadModal(false);
  };

  useImperativeHandle(ref, () => ({
    show: handleShowDownloadModal,
  }));

  const handleDownload = async (type: ExportType) => {
    const fileName = generatedTitle || detailInfo?.title || "";
    const useComplete =
      shareInfo?.origin === Origin.MEETING_PLATE && shareInfo?.fileTransEnable;
    const contentStep = useComplete ? "COMPLETE_DOC" : "SRC_DOC";
    switch (type) {
      case ExportType.exportSrcDoc:
        await summaryCommonStore
          .getState()
          .downloadSrcDoc(fileName, contentStep);
        handleHideDownloadModal();
        break;
      case ExportType.exportSummary:
        await summaryCommonStore
          .getState()
          .downloadSummary(fileName, contentStep);
        handleHideDownloadModal();
        break;
      case ExportType.exportAudio:
        await summaryCommonStore.getState().downloadAudio(fileName);
        handleHideDownloadModal();
        break;
      case ExportType.exportSpeechDraft:
        await summaryCommonStore.getState().downloadSpeechDraft(fileName);
        handleHideDownloadModal();
        break;
      default:
        break;
    }
  };

  return (
    <>
      <ActionSheet
        visible={showDownloadModal}
        setVisible={setShowDownloadModal}
      >
        <div className="w-full absolute bottom-0 bg-white rounded-4 rounded-b-0 pt-4 pb-8.5 text-mx-secondary text-4 text-center">
          {srcDone && <div
            className="py-3.5"
            onClick={() => handleDownload(ExportType.exportSrcDoc)}
          >
            {exportTypeNameMap[ExportType.exportSrcDoc]}
          </div>}
          {summaryDone && <div
            className="py-3.5"
            onClick={() => handleDownload(ExportType.exportSummary)}
          >
            {exportTypeNameMap[ExportType.exportSummary]}
          </div>}
          {audioDone && (
            <div
              className="py-3.5"
              onClick={() => handleDownload(ExportType.exportAudio)}
            >
              {exportTypeNameMap[ExportType.exportAudio]}
            </div>
          )}
          {speechDraftDone && (
            <div
              className="py-3.5"
              onClick={() => handleDownload(ExportType.exportSpeechDraft)}
            >
              {exportTypeNameMap[ExportType.exportSpeechDraft]}
            </div>
          )}
          <div
            className="mt-4 mx-6 py-2.5 bg-#F4F6F9 rounded-2.5"
            onClick={handleHideDownloadModal}
          >
            取 消
          </div>
        </div>
      </ActionSheet>
      <DownloadTip
        visible={showDownloadTip}
        onClose={() => setShowDownloadTip(false)}
      />
    </>
  );
});

export default MobileExportModal;
